import React, {useRef} from 'react';
import {useParams} from 'react-router-dom';
import notify from '@utils/notify';

import {Col, Container, Row,} from "reactstrap";
import CardsHeader from 'layouts/Headers/CardsHeader.js';
import {LeadsContextProvider} from './context';
import DetailsSection from './sections/DetailsSection';
import QuotesSection from './sections/QuotesSection';
import LeadQuoteSection from "@pages/lead/sections/LeadQuoteSection";

export default function LeadEdit() {

  const { id } = useParams();

  return (
    <LeadsContextProvider id={id} notify={notify}>
      <CardsHeader name="Leads" parentName="Leads Management" currentName="Edit" />
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            {/* Header */}
           <div className={'d-flex flex-wrap justify-content-around g-10'}>
             <DetailsSection />
             <QuotesSection />
           </div>
            <LeadQuoteSection/>
          </Col>
        </Row>
        </Container>
    </LeadsContextProvider>
  )
}